import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";
import { CalendarIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import { format } from "date-fns/format";
import React, { useEffect, useState } from "react";

interface Props {
  dueDate: string;
  onDateChange: (val: string) => void;
  onOpen: () => void;
  onClose: () => void;
}
const DueDateSection: React.FC<Props> = ({
  dueDate,
  onDateChange,
  onClose,
  onOpen,
}) => {

  const [selectedDate, setSelectedDate] = useState<Date | null>(
    dueDate ? new Date(dueDate) : null
  );
 // ✅ Sync selectedDate with dueDate prop
  useEffect(() => {
    if (dueDate?.trim()) {
      const parsed = new Date(dueDate);
      if (!isNaN(parsed.getTime())) {
        setSelectedDate(parsed);
      } else {
        setSelectedDate(null);
      }
    } else {
      setSelectedDate(null);
    }
  }, [dueDate]);

  const handleChange = (val: Date | null) => {
    if (val) {
      setSelectedDate(val);
      onDateChange?.(val.toISOString());
    }
  };
  return (
    <React.Fragment>
      <AdaptiveDatePicker
        value={selectedDate}
        onChange={(v) => {
          handleChange(v);
        }}
        trigger={
          <button className="flex items-center justify-between w-full p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <CustomTooltip
              text="Set due date"
              className="flex items-center gap-1 "
              position="left"
            >
              {selectedDate ? (
                <div className="flex  gap-2">
                  <CalendarIcon size={16} color="#79808A" />
                  <span className={`text-sm font-normal text-secondary`}>
                    {format(selectedDate, "dd MMM, yyyy")}
                  </span>
                </div>
              ) : (
                <span className="text-xs leading-[18px] font-normal text-secondary ">
                  Choose due date
                </span>
              )}
            </CustomTooltip>
          </button>
        }
        onClose={onClose}
        onOpen={onOpen}
        isDisablePastDate={true}
      />
    </React.Fragment>
  );
};

export default DueDateSection;
